import React from "react";
import { FaLinkedinIn } from "react-icons/fa";
import { SiGithub, SiGmail } from "react-icons/si";
import { useData } from "../../config/DataContext";
import { motion } from 'framer-motion';

const ContactLeft = () => {
  const { portfolio } = useData();

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="w-full lgl:w-[35%] h-full py-6 rounded-xl border border-white/10 bg-white/5 backdrop-blur-md p-5 lgl:p-6 flex flex-col gap-4 justify-center"
    >
      {portfolio.map((items, index) => (
        <div key={index} className="flex flex-col gap-3">
          <h3 className="text-2xl font-bold text-white font-titleFont gradientText">{items.name}</h3>
          <p className="text-sm font-normal text-gray-400">{items.lates_skills && items.lates_skills[1]}</p>
          <p className="text-xs text-gray-400 leading-relaxed">{items.dec_1}</p>

          <div className="flex flex-col gap-2 mt-1">
            <p className="text-xs text-gray-400 flex items-center gap-2">
              Phone: <span className="text-white">{items.phone}</span>
            </p>
            <p className="text-xs text-gray-400 flex items-center gap-2">
              Email: <span className="text-white">{items.email}</span>
            </p>
          </div>

          <div className="flex gap-2 mt-1">
            <a href={items.github || "#"} target="_blank" rel="noopener noreferrer" className="bannerIcon !w-10 !h-10">
              <SiGithub />
            </a>
            <a href={`mailto:${items.email}`} className="bannerIcon !w-10 !h-10">
              <SiGmail />
            </a>
            <a href={items.linkedin || "#"} target="_blank" rel="noopener noreferrer" className="bannerIcon !w-10 !h-10">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      ))}
    </motion.div>
  );
};

export default ContactLeft;
